<div class="theme_bg">
	<div class="container nopad">
		<app-booking-steps [travellers]="true" [passengerDetails]="true"></app-booking-steps>
		<h3 _ngcontent-vdt-c225 class="review_txt">Guest details</h3>
		<div class="mb-2 mt-2" style="border:none;">
			<div class="card-body pb-3">
				<app-booking-flight-detail [flight]="flight" [traveller]="traveller"></app-booking-flight-detail>
				<div class="row mobile_row">
					<div class="col-md-8 col-lg-8 nopad">
						<form [formGroup]="contactForm" class="needs-validation" novalidate
							(validSubmit)="onSubmitBooking()">
							<div class="card mt-3" style="box-shadow: 0px 1px 16px #ddd;" *ngIf="!currentUser">
								<div class="card-body">
									<a href="" data-toggle="modal" data-target="#show_log" >
										<h5 class="card-title">Login or register to enjoy this member-only benifit</h5>
									</a>
									<a class="card-link" style="color: #189AD3;" data-toggle="modal"
										data-target="#show_log">
										LogIn or Register Now</a>
								</div>
							</div>
							<div class="clearfix"></div>
							<h3 _ngcontent-lbw-c186="" class="inpagehed">Contact Details</h3>

							<div class="sectionbuk billingnob" style="">
								<div formGroupName="contact" class="col-md-12 col-lg-12 nopad">
									<h6 _ngcontent-lbw-c186="">Contact Details (For E-ticket/voucher)</h6>
									<div class="clearfix"></div>
									<div class="col-md-12">

										<div class="form-row form-group">
											<div class="col-md-3">
												<label>Title <b class="text-danger">*</b></label>
												<select *ngIf="titles.length" formControlName="Title"
													class="form-control form-control-sm payinput capitalize">
													<option value='' disabled>Select</option>
													<ng-container *ngFor="let t of titles">
														<option *ngIf="t.paxType == 'ADULT'" [value]="t.titleName">
															{{t.titleName}}
														</option>
													</ng-container>
												</select>
											</div>
											<div class="col-md-5">
												<label>First Name <b class="text-danger">*</b></label>
												<input formControlName="FirstName" type="text" style="text-transform: uppercase;"
													class="form-control form-control-sm payinput"
													placeholder="First Name" oninput="this.value = this.value.toUpperCase()">
												<div class="">
													<small class="error text-danger"
														*ngIf="hasContactError('FirstName', 'required', 'contact');">
														Please Enter First Name* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('FirstName', 'maxlength', 'contact');">
														Maximum Characters Exceeded* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('FirstName', 'minlength', 'contact');">
														At Least 1 Character Required* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('FirstName', 'pattern', 'contact');">
														Please Enter a Valid Name* <br>
													</small>
												</div>
											</div>
											
											<div class="col-md-4">
												<label>Last Name <b class="text-danger">*</b></label>
												<input formControlName="LastName" type="text"
													class="form-control form-control-sm payinput" style="text-transform: uppercase;"
													placeholder="Last Name" oninput="this.value = this.value.toUpperCase()">
												<div class="">
													<small class="error text-danger"
														*ngIf="hasContactError('LastName', 'required', 'contact');">
														Please Enter Last Name* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('LastName', 'maxlength', 'contact');">
														Maximum Characters Exceeded* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('LastName', 'minlength', 'contact');">
														At Least 1 Character Required* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('LastName', 'pattern', 'contact');">
														Please Enter a Valid Name* <br>
													</small>
												</div>
											</div>
											<div class="col-md-4">
												<label>Country Code <b class="text-danger">*</b></label>
												<select #selectedCountry formControlName="countryCode"
													(change)="onUpdatePassenges(selectedCountry.value)"
													class="form-control form-control-sm payinput">
													<option [selected]="p.id == 281"
														*ngFor="let p of phoneCodes">
														{{p.name}}({{ p.phone_code }}) </option>
												</select>
												<div class="">
													<small class="error text-danger"
														*ngIf="hasContactError('countryCode', 'required', 'contact');">
														Select Country Code* <br>
													</small>
												</div>
											</div>
											<div class="col-md-4">
												<label>Phone Number <b class="text-danger">*</b></label>
												<input formControlName="phoneNumber" type="text"
													(keypress)="numberOnly($event)" maxlength="10"
													class="form-control form-control-sm payinput"
													placeholder="1234567890">
												<div class="">
													<small class="error text-danger"
														*ngIf="hasContactError('phoneNumber', 'required', 'contact');">
														Please Enter Phone Number* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('phoneNumber', 'maxlength', 'contact');">
														Maximum Characters Exceeded* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('phoneNumber', 'minlength', 'contact');">
														At Least 1 Character Required* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('phoneNumber', 'pattern', 'contact');">
														Please Enter a Valid Number* <br>
													</small>
													<span class="pass_de">
														e.g +20 1234 567890, for country code (+20) and Mobile Number
														1234
														567890.
													</span>
												</div>
											</div>
											<div class="col-md-4">
												<label>Email <b class="text-danger">*</b></label>
												<input formControlName="email" type="email"
													class="form-control payinput form-control-sm" maxlength="40"
													placeholder="example@gmail.com">
												<div class="">
													<small class="error text-danger"
														*ngIf="hasContactError('email', 'required', 'contact');">
														Please Enter Email* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('email', 'maxlength', 'contact');">
														Maximum Characters Exceeded* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('email', 'minlength', 'contact');">
														At Least 1 Character Required* <br>
													</small>
													<small class="error text-danger"
														*ngIf="hasContactError('email', 'pattern', 'contact');">
														Please Enter a Valid Email* <br>
													</small>
												</div>
												<span class="pass_de">
													e.g email@example.com
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="clearfix"></div>
							<!-- ****************************************************************************************** -->
							<div class="sectionbuk billingnob" style="box-shadow: 0px 1px 16px #ddd;">
								<div class="col-md-12 col-lg-12 nopad">
									<div style="padding: 0px; margin: 0px;" class="alert  col-md-12 col-lg-12"
										role="alert">
										<ng-template #popTemplate>
											<div [innerHtml]="html" container="body"></div>
										</ng-template>
									</div>
								</div>
							</div>
							<div class="sectionbuk billingnob" style="box-shadow: 0px 1px 16px #ddd;">
								<div class="mt-1 ml-2">
									<h4 class="inpagehed">Traveller Details</h4>
									<div
										style="color: #189AD3;padding: 0px 0px; float: left; width: 100%; margin-bottom: 10px; display: block; font-size: 15px;">
										Important : Passport valid for atleast 6
										months from
										departure date is required for international travel or transit
										abroad. </div>
								</div>
								<ng-container formArrayName="passengers">
									<ng-container
										*ngFor="let item of contactForm.get('passengers')['controls']; let i = index;">
										<div style="float: right;" class="mr-3" *ngIf="i===0">
											<button (click)="copyContact()"
												class="btn-pill mb-2 mr-2 btn srch_btn">
												Copy Details </button>
										</div>
										<div class="clearfix"></div>
										<div [formGroupName]="i">
											<div>
												<div class="col-md-12 col-lg-12 nopad">
													<div *ngIf="item.get('travellerType').value == 'adults'">
														<div class="col-md-12 pb-1">
															<div *ngIf="travelList && travelList.length>0">
																<label class="textWeight">Select Adult {{ item.get('travellerTypeCount').value }}</label>
																<mat-form-field class="col-md-3 f-16 ml-1" appearance="fill">
																	<mat-label>Select Adult</mat-label>
																	<mat-select formControlName="PassengerSelection" id="matselectAdult{{i}}">
																		<mat-option value="" disabled>Select Adult</mat-option>
																		<mat-option *ngFor="let option of travelList" [value]="option.first_name"
																			(click)="setAdultDetails(option,i,'adults')">
																			{{option.first_name}}
																		</mat-option>
																	</mat-select>
																</mat-form-field>
																<a class="passengerClear" (click)="clearDetails(i)"> Clear</a>
															</div>

															<div class="form-row form-group row">
																<div class="form-group col-md-1 mt-4"
																	style="color: #189AD3;">
																	Adult {{ item.get('travellerTypeCount').value }}
																</div>

																<div class="col-md-2">
																	<label>Title <b class="text-danger">*</b></label>
																	<select *ngIf="titles.length"
																		formControlName="Title"
																		class="form-control form-control-sm payinput capitalize">
																		<option value='' disabled>Select</option>
																		<ng-container *ngFor="let t of titles">
																			<option *ngIf="t.paxType == 'ADULT'" [value]="t.titleName">
																				{{t.titleName}}
																			</option>
																		</ng-container>
																	</select>
																	<small class="error text-danger"
																			*ngIf="hasError('Title', 'required', 'passengers', i);">
																			Please Select Title* <br>
																		</small>
																</div>
																<div class="col-md-5">
																	<label>First Name <b class="text-danger">*</b></label>
																	<input formControlName="FirstName" type="text"
																		maxlength="50" style="text-transform: uppercase;"
																		class="form-control form-control-sm payinput"
																		placeholder="First Name" oninput="this.value = this.value.toUpperCase()" >
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'required', 'passengers', i);">
																			Please Enter First Name* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'maxlength', 'passengers', i);">
																			Maximum Characters Exceeded* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'minlength', 'passengers', i);">
																			At Least 1 Character Required* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'pattern', 'passengers', i);">
																			Please Enter a Valid Name* <br>
																		</small>
																	</div>
																</div>
																
																<div class="col-md-4">
																	<label>Last Name <b class="text-danger">*</b></label>
																	<input formControlName="LastName" type="text"
																		maxlength="50" style="text-transform: uppercase;"
																		class="form-control form-control-sm payinput"
																		placeholder="Last Name" oninput="this.value = this.value.toUpperCase()">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'required', 'passengers', i);">
																			Please Enter Last Name* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'maxlength', 'passengers', i);">
																			Maximum Characters Exceeded* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'minlength', 'passengers', i);">
																			At Least 1 Character Required* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'pattern', 'passengers', i);">
																			Please Enter a Valid Name* <br>
																		</small>
																	</div>
																</div>
																<div class="col-md-3">
																	<label>Date of Birth <b class="text-danger">*</b></label>
																	<input bsDatepicker 
																		 [readonly]="true"
																		placement="bottom left" [bsConfig]="bsDateConf"
																		formControlName="DateOfBirth" type="text"
																		class="form-control form-control-sm payinput"
																		placeholder="D.O.B" [minDate]="minDateAdult" [maxDate]="maxDateAdult">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('DateOfBirth', 'required', 'passengers', i);">
																			Please Select DOB* <br>
																		</small>
																		<small class="error text-danger" *ngIf="hasError('DateOfBirth', 'bsDate', 'passengers', i);">Enter Valid DOB</small>
																	</div>
																</div>
																<div class="col-md-3" *ngIf="flightType === 'International'">
																	<label>Country of Issue <b class="text-danger">*</b></label>
																	<select formControlName="PassportIssuingCountry"
																		class="form-control form-control-sm payinput">
																		<option *ngFor="let c of countries"
																			[value]="c.code">
																			{{c.name}}</option>
																	</select>
																</div>
																<div class="col-md-3">
																	<label>Gender <b class="text-danger">*</b></label>
																	<select formControlName="Gender"
																		class="form-control form-control-sm payinput">
																		<option selected value="" disabled>Select</option>
																		<option value="Male"> Male </option>
																		<option value="Female"> Female </option>
																	</select>
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('Gender', 'required', 'passengers', i);">
																			Please Select Gender* <br>
																		</small>
																	</div>
																</div>
																<div class="col-md-3">
																	<label>Nationality <b class="text-danger">*</b></label>
																	<select formControlName="Nationality"
																		class="form-control form-control-sm payinput">
																		<option *ngFor="let c of countries"
																			[value]="c.code">
																			{{c.name}}</option>
																	</select>
																</div>
																<div class="col-md-3" *ngIf="flightType === 'International'">
																	<label>Passport Number <b *ngIf="flightType == 'International'" class="text-danger">*</b></label>
																	<input formControlName="PassportNumber" type="text" style="text-transform: uppercase;"
																		maxlength="20"
																		class="form-control form-control-sm payinput"
																		placeholder="Passport Number" (keypress)="alphaNumberOnly($event)" [minDate]="maxDate">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('PassportNumber', 'required', 'passengers', i);">
																			Please Enter Passport Number <br>
																		</small>
																	</div>
																</div>
																<div class="col-md-3" *ngIf="flightType === 'International'">
																	<label>Expiry Date <b *ngIf="flightType == 'International'" class="text-danger">*</b></label>
																	<input bsDatepicker 
																		formControlName="PassportExpiryDate"
																		[readonly]="true" placement="bottom left"
																		[bsConfig]="bsDateConf" type="text"
																		class="form-control form-control-sm payinput"
																		placeholder="Date of Expire" [minDate]="maxDate">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('PassportExpiryDate', 'required', 'passengers', i);">
																			Please Select Passport Expiry Date <br>
																		</small>
																		<small class="error text-danger" *ngIf="hasError('PassportExpiryDate', 'bsDate', 'passengers', i);">Enter Valid Passport Expiry</small>
																	</div>
																</div>
															</div>
														</div>
													</div>

													<div *ngIf="item.get('travellerType').value == 'childrens'">
														<div class="clearfix"></div>
														<div class="col-md-12 pb-1">
															<div *ngIf="travelList && travelList.length>0">
																<label class="textWeight">Select Child {{ item.get('travellerTypeCount').value }}</label>
																<mat-form-field class="col-md-3 f-16 ml-1" appearance="fill">
																	<mat-label>Select Child</mat-label>
																	<mat-select formControlName="PassengerSelection" id="matselectChild{{i}}">
																		<mat-option value="" disabled>Select Child</mat-option>
																		<mat-option *ngFor="let option of travelList" [value]="option.first_name"
																			(click)="setAdultDetails(option,i, 'childrens')">
																			{{option.first_name}}
																		</mat-option>
																	</mat-select>
																</mat-form-field>
																<a class="passengerClear" (click)="clearDetails(i)"> Clear</a>
															</div>
															<div class="form-row form-group row">
																<div class="form-group col-md-1 mt-4"
																	style="color: #189AD3;">
																	Child {{ item.get('travellerTypeCount').value }}
																</div>
																<div class="col-md-2">
																	<label>Title <b class="text-danger">*</b></label>
																	<select formControlName="Title" class="form-control form-control-sm payinput capitalize">
																		<option value='' disabled>Select</option>
																		<ng-container *ngFor="let t of titles">
																			<option *ngIf="t.paxType == 'CHILD'" [value]="t.titleName">
																				{{t.titleName}}
																			</option>
																		</ng-container>
																	</select>
																	<small class="error text-danger"
																			*ngIf="hasError('Title', 'required', 'passengers', i);">
																			Please Select Title* <br>
																		</small>
																</div>
																<div class="col-md-5">
																	<label>First Name <b class="text-danger">*</b></label>
																	<input formControlName="FirstName" type="text"
																		maxlength="50" style="text-transform: uppercase;"
																		class="form-control form-control-sm payinput"
																		placeholder="First Name" oninput="this.value = this.value.toUpperCase()">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'required', 'passengers', i);">
																			Please Enter First Name* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'maxlength', 'passengers', i);">
																			Maximum Characters Exceeded* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'minlength', 'passengers', i);">
																			At Least 1 Character Required* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'pattern', 'passengers', i);">
																			Please Enter a Valid Name* <br>
																		</small>
																	</div>
																</div>
																<div class="col-md-4">
																	<label>Last Name <b class="text-danger">*</b></label>
																	<input formControlName="LastName" type="text"
																		maxlength="50" style="text-transform: uppercase;"
																		class="form-control form-control-sm payinput"
																		placeholder="Last Name" oninput="this.value = this.value.toUpperCase()">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'required', 'passengers', i);">
																			Please Enter Last Name* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'maxlength', 'passengers', i);">
																			Maximum Characters Exceeded* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'minlength', 'passengers', i);">
																			At Least 1 Character Required* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'pattern', 'passengers', i);">
																			Please Enter a Valid Name* <br>
																		</small>
																	</div>
																</div>
																<div class="clearfix"></div>
																<div class="col-md-3">
																	<label>Date of Birth <b class="text-danger">*</b></label>
																	<input bsDatepicker 
																		 [readonly]="true"
																		placement="bottom left" [bsConfig]="bsDateConf"
																		formControlName="DateOfBirth" type="text"
																		class="form-control form-control-sm payinput"
																		placeholder="D.O.B" [minDate]="minDateChild" [maxDate]="maxDateChild">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('DateOfBirth', 'required', 'passengers', i);">
																			Please Select DOB* <br>
																		</small>
																		<small class="error text-danger" *ngIf="hasError('DateOfBirth', 'bsDate', 'passengers', i);">Enter Valid DOB</small>
																	</div>
																</div>
																<div class="col-md-3">
																	<label>Country of Issue <b class="text-danger">*</b></label>
																	<select formControlName="PassportIssuingCountry"
																		class="form-control form-control-sm payinput">
																		<option *ngFor="let c of countries"
																			[value]="c.code">
																			{{c.name}}</option>
																	</select>
																</div>
																<div class="col-md-3">
																	<label>Gender <b class="text-danger">*</b></label>
																	<select formControlName="Gender"
																		class="form-control form-control-sm payinput">
																		<option selected value="" disabled>Select</option>
																		<option value="Male"> Male </option>
																		<option value="Female"> Female </option>
																	</select>
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('Gender', 'required', 'passengers', i);">
																			Please Select Gender* <br>
																		</small>
																	</div>
																</div>
																<div class="col-md-3">
																	<label>Nationality <b class="text-danger">*</b></label>
																	<select formControlName="Nationality"
																		class="form-control form-control-sm payinput">
																		<option *ngFor="let c of countries"
																			[value]="c.code">
																			{{c.name}}</option>
																	</select>
																</div>
																<div class="clearfix"></div>
																<div class="col-md-3" *ngIf="flightType === 'International'">
																	<label>Passport Number <b *ngIf="flightType == 'International'" class="text-danger">*</b></label>
																	<input formControlName="PassportNumber" type="text"
																		maxlength="20"
																		class="form-control form-control-sm payinput capitalize"
																		placeholder="Passport Number" (keypress)="alphaNumberOnly($event)">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('PassportNumber', 'required', 'passengers', i);">
																			Please Enter Passport Number <br>
																		</small>
																	</div>
																</div>
																<div class="form-group col-md-3" *ngIf="flightType === 'International'">
																	<label>Expiry Date <b *ngIf="flightType == 'International'" class="text-danger">*</b></label>
																	<input bsDatepicker
																		formControlName="PassportExpiryDate"
																		[readonly]="true" placement="bottom left"
																		[bsConfig]="bsDateConf" type="text"
																		class="form-control form-control-sm payinput"
																		placeholder="Date of Expire" [minDate]="maxDate">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('PassportExpiryDate', 'required', 'passengers', i);">
																			Please Select Passport Expiry Date <br>
																		</small>
																		<small class="error text-danger" *ngIf="hasError('PassportExpiryDate', 'bsDate', 'passengers', i);">Enter Valid Passport Expiry</small>
																	</div>
																</div>
															</div>
														</div>
													</div>

													<div *ngIf="item.get('travellerType').value == 'infants'">
														<div class="col-md-12 pb-1">
															<div *ngIf="travelList && travelList.length>0">
																<label class="textWeight">Select Infant {{ item.get('travellerTypeCount').value }}</label>
																<mat-form-field class="col-md-3 f-16 ml-1" appearance="fill">
																	<mat-label>Select Infant</mat-label>
																	<mat-select formControlName="PassengerSelection" id="matselectInfant{{i}}">
																		<mat-option value="" disabled>Select Infant</mat-option>
																		<mat-option *ngFor="let option of travelList" [value]="option.first_name"
																			(click)="setAdultDetails(option,i,'infants')">
																			{{option.first_name}}
																		</mat-option>
																	</mat-select>
																</mat-form-field>
																<a class="passengerClear" (click)="clearDetails(i)"> Clear</a>
															</div>
															<div class="form-row row form-group ">
																<div class="form-group col-md-1 mt-4"
																	style="color: #189AD3;">
																	Infant {{ item.get('travellerTypeCount').value }}
																</div>
																<div class="col-md-2">
																	<label>Title <b class="text-danger">*</b></label>
																	<select formControlName="Title"
																		class="form-control form-control-sm payinput capitalize">
																		<option value='' disabled>Select</option>
																		<ng-container *ngFor="let t of titles">
																			<option *ngIf="t.paxType == 'CHILD'" [value]="t.titleName">
																				{{t.titleName}}</option>
																		</ng-container>
																	</select>
																	<small class="error text-danger"
																			*ngIf="hasError('Title', 'required', 'passengers', i);">
																			Please Select Title* <br>
																		</small>
																</div>
																<div class="col-md-5">
																	<label>First Name <b class="text-danger">*</b></label>
																	<input formControlName="FirstName" type="text"
																		maxlength="50" style="text-transform: uppercase;"
																		class="form-control form-control-sm payinput"
																		placeholder="First Name" oninput="this.value = this.value.toUpperCase()">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'required', 'passengers', i);">
																			Please Enter First Name* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'maxlength', 'passengers', i);">
																			Maximum Characters Exceeded* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'minlength', 'passengers', i);">
																			At Least 1 Character Required* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('FirstName', 'pattern', 'passengers', i);">
																			Please Enter a Valid Name* <br>
																		</small>
																	</div>
																</div>
																
																<div class="col-md-4">
																	<label>Last Name <b class="text-danger">*</b></label>
																	<input formControlName="LastName" type="text"
																		maxlength="50" style="text-transform: uppercase;"
																		class="form-control form-control-sm payinput"
																		placeholder="Last Name" oninput="this.value = this.value.toUpperCase()">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'required', 'passengers', i);">
																			Please Enter Last Name* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'maxlength', 'passengers', i);">
																			Maximum Characters Exceeded* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'minlength', 'passengers', i);">
																			At Least 1 Character Required* <br>
																		</small>
																		<small class="error text-danger"
																			*ngIf="hasError('LastName', 'pattern', 'passengers', i);">
																			Please Enter a Valid Name* <br>
																		</small>
																	</div>
																</div>
																<div class="clearfix"></div>
																<div class="col-md-3">
																	<label>Date of Birth <b class="text-danger">*</b></label>
																	<input bsDatepicker 
																		 [readonly]="true"
																		placement="bottom left" [bsConfig]="bsDateConf"
																		formControlName="DateOfBirth" type="text"
																		class="form-control form-control-sm payinput"
																		placeholder="D.O.B" [minDate]="minDateInfant" [maxDate]="maxDateInfant">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('DateOfBirth', 'required', 'passengers', i);">
																			Please Select DOB* <br>
																		</small>
																		<small class="error text-danger" *ngIf="hasError('DateOfBirth', 'bsDate', 'passengers', i);">Enter Valid DOB</small>
																	</div>
																</div>
																<div class="col-md-3">
																	<label>Country of Issue <b class="text-danger">*</b></label>
																	<select formControlName="PassportIssuingCountry"
																		class="form-control form-control-sm payinput">
																		<option *ngFor="let c of countries"
																			[value]="c.code">
																			{{c.name}}</option>
																	</select>
																</div>
																<div class="col-md-3">
																	<label>Gender <b class="text-danger">*</b></label>
																	<select formControlName="Gender"
																		class="form-control form-control-sm payinput">
																		<option selected value="" disabled>Select</option>
																		<option value="Male"> Male </option>
																		<option value="Female"> Female </option>
																	</select>
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('Gender', 'required', 'passengers', i);">
																			Please Select Gender* <br>
																		</small>
																	</div>
																</div>
																<div class="col-md-3">
																	<label>Nationality <b class="text-danger">*</b></label>
																	<select formControlName="Nationality"
																		class="form-control form-control-sm payinput">
																		<option *ngFor="let c of countries"
																			[value]="c.code">
																			{{c.name}}</option>
																	</select>
																</div>
																<div class="clearfix"></div>
																<div class="col-md-3" *ngIf="flightType === 'International'">
																	<label>Passport Number <b *ngIf="flightType == 'International'" class="text-danger">*</b></label>
																	<input formControlName="PassportNumber" type="text"
																		maxlength="20" style="text-transform: uppercase;"
																		class="form-control form-control-sm payinput" style="text-transform: uppercase;"
																		placeholder="Passport Number" (keypress)="alphaNumberOnly($event)">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('PassportNumber', 'required', 'passengers', i);">
																			Please Enter Passport Number <br>
																		</small>
																	</div>
																</div>
																<div class="col-md-3" *ngIf="flightType === 'International'">
																	<label>Expiry Date <b *ngIf="flightType == 'International'" class="text-danger">*</b></label>
																	<input bsDatepicker 
																		formControlName="PassportExpiryDate"
																		[readonly]="true" placement="bottom left"
																		[bsConfig]="bsDateConf" type="text"
																		class="form-control form-control-sm payinput"
																		placeholder="Date of Expire" [minDate]="maxDate">
																	<div class="">
																		<small class="error text-danger"
																			*ngIf="hasError('PassportExpiryDate', 'required', 'passengers', i);">
																			Please Select Passport Expiry Date <br>
																		</small>
																		<small class="error text-danger" *ngIf="hasError('PassportExpiryDate', 'bsDate', 'passengers', i);">Enter Valid Passport Expiry</small>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<hr *ngIf="passengers.controls.length > i + 1" />
										</div>
									</ng-container>
								</ng-container>
								<div *ngIf="flight && flight['Attr']['is_usa']" class="my-3 py-4 border rounded"> <span
										class="f-20 text-info text-upercase float-left">
										<i class="text-danger ion-md-globe"></i> Ticket to <span class="text-danger">
											USA
										</span> to add additional information </span>
									<div class="col-md-12 mt-4 text-muted f-12">
										<div formGroupName="usaDetailsForm" class="col-md-12 col-lg-12">
											<div class="form-row">
												<div class="form-group col-md-4">
													<input type="text" formControlName="country_name" readonly
														class="form-control form-control-sm" [value]="'USA'"
														placeholder="">
												</div>
												<div class="form-group col-md-4">
													<select formControlName="gender" #selectedCountry
														class="form-control form-control-sm">
														<option value="Male"> Male </option>
														<option value="Female"> Female </option>
														<option value="Others"> Others </option>
													</select>
												</div>
												<div class="form-group col-md-4">
													<select formControlName="types" #selectedCountry
														class="form-control form-control-sm">
														<option value="resident"> Resident </option>
														<option value="official"> Official </option>
													</select>
												</div>
											</div>
											<div class="form-row">
												<div class="form-group col-md-12">
													<textarea formControlName="address"
														class="form-control form-control-sm" rows="2"
														placeholder="Address"></textarea>
												</div>
											</div>
											<div class="form-row">
												<div class="form-group col-md-4">
													<input formControlName="city" type="text"
														class="form-control form-control-sm" placeholder="City">
												</div>
												<div class="form-group col-md-4">
													<input formControlName="state" type="text"
														class="form-control form-control-sm" placeholder="State">
												</div>
												<div class="form-group col-md-4">
													<input formControlName="postal_code" type="text"
														class="form-control form-control-sm" placeholder="Postal COde">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="row mt-3 py-3 rounded border card">
                            <div class="col-md-12 col-lg-12">
                                <h4 class="text-muted cardListHead px-0"> Lost Baggage Protection </h4>
                                <div class="">
                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <span class="font-weight-bold pt-2">
                                                For USD $5.00 per traveller:
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-12 form-group p-3 border rounded">
                                            <p class="">
                                                <i class="fa fa-check text-success" aria-hidden="true"> </i>
                                                Blue Ribbon Bags will track and expedite your delayed bagage
                                            </p>
                                            <p class="">
                                                <i class="fa fa-check text-success" aria-hidden="true"> </i>
                                                Provides real-time push notifications via email or SMS regarding the status
                                                of your bagage
                                            </p>
                                            <p class="">
                                                <i class="fa fa-check text-success" aria-hidden="true"> </i>
                                                Receive USD $1,000.00 if your bag is not at the destination within 96 hours
                                            </p>
                                        </div>
                                    </div>
                                    <div class="form-row mt-4">
                                        <div class="form-group col-md-12">
                                            <input formControlName="baggageProtection" [value]="true" type="radio" name="" id="yes" class=""> <label for="yes"
                                                class="" (click)="getBaggageProtection(true)">
                                                Yes, add to my reservation <span class="text-success ml-3"> HIGHLY RECOMMENDED
                                                </span>
                                            </label>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <input formControlName="baggageProtection" [value]="false" type="radio" name="" id="no" class=""> <label for="no"
                                                class="" (click)="getBaggageProtection(false)">
                                                No I'll run the risk
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
						 <!-- Seat selection start -->
						 <div class="row mt-3 py-3 rounded border card" *ngIf="showSeatSelection">
							<div class="col-md-12 col-lg-12">
								<h4 class="text-muted" style="color:#189AD3 !important;"> Seat Selection </h4>
								<div class="panel-body  d-flex col-12">
									<div class="col-md-3 set_margin spllty splinmar">
										<img class="seatImage" src="assets/images/seat_sel.jpg">
									</div>
									<div class="col-md-7 set_margin mt-3 spllty splinmar">
										<div class="well seat_well sel_seat_well">
											<div style="width: 100%;">
												<p style="margin:0px;">
													<b style="color: #2196F3;">Aisle or Window ? </b>
													<br>
													For extra peace of mind reserve your preffered seat now.
												</p>
											</div>
										</div>
										<div class="chooseSeatSec">
											<div class="col-md-12 nopad" *ngIf="!isSeatLoading && (seatMapSectors && seatMapSectors?.size>0)">
												<div class="btn mail_box_btn seat_sel_btn collapsed" data-toggle="collapse"
													data-target="#seat_sel" aria-expanded="false">Choose Your Seat</div>
												<div class="inlineSec">
												</div>
											</div>
											<div class="col-md-12 nopad" *ngIf="!isSeatLoading && (!seatMapSectors || seatMapSectors?.size==0)">
												<div class="text-center">No Seats Available</div>
												<div class="inlineSec">
												</div>
											</div>
											<div class="inlineSec" >
												<div *ngIf="isSeatLoading" style="text-align: center; margin-top: 50px; margin-bottom: 50px;"  >
													<br/>
													<br/>
													<br/>
													<div class="spinner-grow text-primary" role="status">
														<span class="sr-only">Loading...</span>
													</div>
													<div class="spinner-grow text-secondary" role="status">
														<span class="sr-only">Loading...</span>
													</div>
												</div>
												<table class="table table-striped">
													<tbody>
														<ng-container
															*ngFor="let selectedSector of seatMapSectors | keyvalue : originalOrder">
															<tr>
																<td>{{selectedSector.key.split(',')[2]}}-{{selectedSector.key.split(',')[3]}}
																</td>
																<td>
																	<ng-container *ngFor="let selectedSeats of selectedSector.value | keyvalue; let last = last">
																		<span>{{selectedSeats?.value}}{{last ? '' : ', '}} </span>
																	</ng-container>
																</td>
															</tr>
														</ng-container>
													</tbody>
												</table>
											</div>
											<div *ngIf="keysArray && keysArray.length>0" class="btn remove collapsed" id="remove_selected_seat"
												data-target="#seat_sel" data-toggle="collapse"
												style="display: inline-block;" aria-expanded="false">Remove Your Seat
											</div>
										</div>
									</div>
								</div>
							</div>
							<ng-container formArrayName="passengers">
								<div id="seat_sel" class="col-md-12 collapse hidden">
									<div class="panel-body d-flex col-12">
										<div class="col-md-12 set_margin mt-3 spllty splinmar">
											<ngb-tabset (tabChange)="onTabSelected($event)" [(activeId)]="selectedTabIndex">
												<ngb-tab *ngFor="let item of seatMapData | keyvalue : originalOrder;let sectorIndex = index;" title="{{item.key.split(',')[2]}}-{{item.key.split(',')[3]}}" [id]="sectorIndex">
													<ng-template ngbTabContent>
														 <div class="well seat_well">
															<img src="assets/images/seat_window.png" style="width: 40px;">
															&nbsp; &nbsp; Choose your seat now to avoid disappointment.
															<div class="clearfix"></div>
														</div>
														<div class="col-12 row" style="margin-top: 17px;">
															<div class="col-md-4">
																<div style="margin-top: 20px;">
																	<ng-container *ngFor="let passenger of passengers.controls; let ii = index;" [formGroupName]="ii">
																		<div class="seat_passenger" *ngIf="passenger.get('travellerType').value != 'infants'">
																			<input type="radio" id="label{{ii}}" #optionRef [value]="ii" [checked]="ii === 0" (change)="setSelectedPassenger(ii)"
																			class="seat_radio" name="passengerSelection">
																			<ng-container *ngIf="isSeatSelected(sectorIndex, ii, passenger)">
																				<!-- Seat is selected: show seat value and remove button -->
																				<span class="seatcode" *ngFor="let seats of passenger.get('SelectedSeats').value; let selectedSeatIndex=index;">
																				  <ng-container *ngIf="seats.sectorIndex===sectorIndex && seats.selectedPassenger===ii">{{ seats.SeatCode }}</ng-container>
																				  <a *ngIf="seats.sectorIndex===sectorIndex && seats.selectedPassenger===ii"
																					(click)="removeSeat(item,sectorIndex, seats,ii, passenger)" class="text-danger cancle-btn" style="display: block; color: #C71C22!important; z-index: 999; position: relative;">
																					<i class="fa fa-times"></i>
																				  </a>
																				</span>
																			  </ng-container>
																			  <ng-container *ngIf="!isSeatSelected(sectorIndex, ii,passenger)">
																				<!-- Seat is not selected: show "Not Selected" message -->
																				<label class="seat_label" for="label{{ii}}"><span class="psngr_rgt_box1">Not Selected</span></label>
																				<div class="check"></div>
																			  </ng-container>
																		<b>
																			<p class="A_N_1">{{ passenger.get('FirstName').value}} {{
																				passenger.get('LastName').value}}</p>
																		</b>
																		<b>
																		</b>
																	</div>
																</ng-container>
																</div>
															</div>
															<div class="col-md-8">
																<div class="flightWrap">
																	<div class="flightSeatMatrix international">
																		<div>
																			<div class="seatRow" *ngIf="item.value | keyvalue | slice:0:1 as rows">
																				<div class="seatCol">
																					<div class="seatLabel"></div>
																				</div>
																				<ng-container *ngFor="let columnData of rows[0].value | keyvalue">
																					<div class="seatCol"
																					*ngIf="!(columnData.key.match('\\d+'))">
																						<div class="seatLabel">
																							{{columnData.key}}</div>
																					</div>
																					<div class="seatCol bgWhite"
																					*ngIf="(columnData.key.match('\\d+'))">
																						<div class="seatEmptyLabel">
																						</div>
																					</div>
																				</ng-container>
																				<div class="seatCol">
																					<div class="seatLabel"></div>
																				</div>
																			</div>
																			<div class="seatRow"
																				*ngFor="let rows of item.value | keyvalue : originalOrder">
																				<div class="seatCol">
																					<div>
																						<div class="seatLabel">
																							{{rows.key}}
																						</div>
																					</div>
																				</div>
																				<div *ngFor="let coloumn of rows.value | keyvalue : originalOrder">
																					<div class="seatCol"
																						*ngIf="coloumn?.value?.seatAvailability=='Available'">
																						<div class="relative seat">
																							<div class="seatBlock pointer new_seat_blk ">
																								<label class="seats seat--chargable price" [class.seat--selected]="coloumn?.value?.isSelected"
																									(mouseenter)="tooltip.style.display='block'"
																									(mouseleave)="tooltip.style.display='none'">
																									<input type="checkbox" id=""
																										(change)=onCheckboxChange(item,sectorIndex,coloumn,$event)
																										class="seatBtn seatBtn_DXB_BOM">
																								</label>
																								<div class="tooltiptext" style="display: none;"
																									#tooltip>
																									<ng-container *ngFor="let seatCharacteristics of coloumn?.value?.characteristics">
																										<ng-container [ngSwitch]="seatCharacteristics?.code">
																											<ng-container *ngSwitchCase="'W'">
																												<img src="assets/images/window_seat.jpg" alt="">
																												<div class="pop_img_txt">
																													Window seat
																												</div>
																											</ng-container>
																											<ng-container *ngSwitchCase="'A'">
																												<img src="assets/images/aisle_seat.jpg" alt="">
																												<div class="pop_img_txt">
																													Aisle seat
																												</div>
																											</ng-container>
																											<ng-container *ngSwitchCase="'C'">
																												<img src="assets/images/center_seat.jpg" alt="">
																												<div class="pop_img_txt">
																													Center seat
																												</div>
																											</ng-container>
																										</ng-container>
																									</ng-container>
																									<div class="pop_txt_pd">
																										<ng-container
																											*ngFor="let seatCharacteristics of coloumn?.value?.characteristics">
																											<div class="pop_head" *ngIf="seatCharacteristics?.description">
																												{{seatCharacteristics?.description}}
																											</div>
																										</ng-container>
																										<span
																											class="pop_txt_left">{{coloumn?.value?.SeatCode}}</span><span
																											class="pop_txt_right">
																											{{coloumn?.value?.seat_charge}}
																										</span>
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																					<div class="seatCol"
																						*ngIf="coloumn?.value?.seatAvailability=='Blocked' || coloumn?.value?.seatAvailability=='Occupied'">
																						<div class="relative" id="">
																							<div class="seatNotAvailable">
																								<div class="seats seat--unavailable"> <span class="seat-text">x</span>
																								</div>
																							</div>
																						</div>
																					</div>
																					<div class="seatCol bgWhite" 
																						*ngIf="(coloumn?.value?.Aisle==1 && coloumn?.value?.seatAvailability=='NotExist') ||  coloumn?.value?.seatAvailability=='NoSeat' || coloumn?.value?.seatAvailability=='NotExist'">
																						<div>
																							<div class="seatEmptyLabel">
																							</div>
																						</div>
																					</div>
																				</div>
																				<div class="seatCol">
																					<div>
																						<div class="seatLabel">
																							{{rows.key}}
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</ng-template>
												</ngb-tab>
											</ngb-tabset>
										</div>
									</div>
								</div>
							</ng-container>
						</div>
						<!-- Seat selection end -->
	
							<div class="mt-3 py-3 border rounded" style="display: none;">
								<a class="col-md-12 col-lg-12" (click)="isCollapsedGst = !isCollapsedGst"
									[attr.aria-expanded]="!isCollapsedGst" aria-controls="collapseBasic"> <span
										class="f-20 text-info text-upercase float-left"> GST Information (Optional)
									</span> <span class="float-right">
										<i class="f-20 fa fa-plus fa-plus--lineHeight"></i>
									</span> </a>
								<!-- <div class="col-md-12 mt-4 text-muted f-12" id="collapseBasic" [collapse]="isCollapsedGst"
                                [isAnimated]="true"> -->
								<div class="col-md-12 mt-4 text-muted f-12" id="collapseBasic">
									<div class="form-group row">
										<label for="gstNo" class="col-md-3 col-lg-3 col-sm-3 col-form-label"> GST Number
										</label>
										<div class="col-sm-9 col-md-9 col-lg-9">
											<input type="text" class="form-control form-control-sm" id="gstNo"
												placeholder="ABCD1234E">
										</div>
									</div>
									<div class="form-group row">
										<label for="gstCompName" class="col-md-3 col-lg-3 col-sm-3 col-form-label"> GST
											Company Name </label>
										<div class="col-sm-9 col-md-9 col-lg-9">
											<input type="text" class="form-control form-control-sm" id="gstCompName"
												placeholder="Provab Technosoft Pvt. Ltd.">
										</div>
									</div>
									<div class="form-group row">
										<label for="email" class="col-md-3 col-lg-3 col-sm-3 col-form-label"> Email
										</label>
										<div class="col-sm-9 col-md-9 col-lg-9">
											<input type="email" class="form-control form-control-sm" id="email"
												placeholder="example@gmail.com">
										</div>
									</div>
									<div class="form-group row">
										<label for="phone" class="col-md-3 col-lg-3 col-sm-3 col-form-label"> Phone
											Number
										</label>
										<div class="col-sm-9 col-md-9 col-lg-9">
											<input type="number" class="form-control form-control-sm" id="phone"
												placeholder="1234567890">
										</div>
									</div>
									<div class="form-group row">
										<label for="address" class="col-md-3 col-lg-3 col-sm-3 col-form-label"> Address
										</label>
										<div class="col-sm-9 col-md-9 col-lg-9">
											<input type="text" class="form-control form-control-sm" id="address"
												placeholder="Electronic City Bangaluru">
										</div>
									</div>
									<div class="form-group row">
										<label for="state" class="col-md-3 col-lg-3 col-sm-3 col-form-label"> State
										</label>
										<div class="col-sm-9 col-md-9 col-lg-9">
											<select class="form-control form-control-sm" id="state">
												<option selected>Choose...</option>
												<option>State-2</option>
												<option>State-3</option>
												<option>State-4</option>
												<option>State-5</option>
											</select>
										</div>
									</div>
								</div>
							</div>
							<div *ngIf="extraServices" class="my-3 py-4 border rounded">
								<a class="col-md-12 col-lg-12 {{ !isCollapsedServiceReqs ? 'bbottom pb-3': '' }}"
									(click)="isCollapsedServiceReqs = !isCollapsedServiceReqs"
									[attr.aria-expanded]="!isCollapsedServiceReqs" aria-controls="collapseBasic"> <span
										class="f-20 text-info text-upercase float-left"> Service Requests (Optional)
									</span> <span class="float-right">
										<i class="f-20 fa fa-plus fa-plus--lineHeight"></i>
									</span> </a>
								<!-- <div class="col-md-12 mt-4 text-muted f-12" id="collapseBasic"
                                [collapse]="isCollapsedServiceReqs" [isAnimated]="true"> -->
								<div class="col-md-12 mt-4 text-muted f-12" id="collapseBasic">
									<!-- <app-service-requests [flight]="flight" [passengers]="passengers"
                                    [contactForm]="contactForm"></app-service-requests> -->
								</div>
							</div>
							<!--  -->
							<div class="col-md-12 nopad mt-3">
								<div class="checkcontent" style="overflow: inherit;">
									<div class="customSquaredThree" style="float: left;">
										<input type="checkbox" [checked]="terms" value="0" name="confirm"
											class="filter_airline" id="squaredThree1" aria-required="true" required
											(click)="onTerms($event.target.checked)" />
										<label for="squaredThree1"></label>
									</div>
									<label for="squaredThree1" class="lbllbl"
										style="display: inline; font-size: 14px;color: #082B3A;"> By booking this item ,
										you
										agree to our 
										
										<a data-toggle="modal"(click)="openStaticPage('terms-conditions')"class="colorbl">Terms and Conditions</a>,
											<a data-toggle="modal"(click)="openStaticPage('privacy-policy')" class="colorbl">Privacy Policy</a>
											 and <a data-toggle="modal" (click)="openStaticPage('refund-policy')" class="colorbl">Refund Policy</a></label>.
								</div>
								<div class="text-danger" *ngIf="!terms"> <small> Please accept Terms and
										Conditions/Privacy
										Policy.
									</small> </div>
							</div>
							<div class="btn_book">
								<button type="submit" (click)="onSubmitBooking()"
									class="btn-pill mb-2 mr-2 btn srch_btn">
									Book Now </button>
							</div>
						</form>
						<div class="col-md-12 col-lg-12 nopad">
							<div class="form-row">
								<div class="alert alert-warning text-justify"> <small>
										Most countries require travellers to have a passport valid for more than 3 to 6
										months from the date of entry into or exit from the country. Please check the
										exact rules for your destination country before completing the booking.
									</small> </div>
							</div>
						</div>
					</div>
					<div class="col-md-4 col-lg-4 mt-3 padlt">
						<app-booking-fare-summary [flight]="flight" [showFlightDetails]="false">
						</app-booking-fare-summary>
						<div class="clearfix"></div>
						<div class="bor mar20 coup">
							<div class="prc-h1 prc-cup"> Have a coupon code </div>
							<div class="cpn" id="divCouponCodeApply" style="display: block;">
								<div class="cpn-l">
									<input id="txtCouponCode" [(ngModel)]="txtCouponCodeValue" type="text" value="" placeholder="Enter Coupon Code"
										minlength="1" [disabled]="disableApplyPromo">
								</div>
								<div class="cpn-r">
									<div *ngIf="!disableApplyPromo" class="apl" [class.disabled]="!txtCouponCodeValue" (click)="applyCoupon()" [attr.disabled]="!txtCouponCodeValue ? true : null">Apply</div>
									<div *ngIf="disableApplyPromo" class="apl" (click)="removeSelectedPromo()">Remove</div>
								</div>
							</div>
							<div *ngIf="isInvalidPromo" class="error-message" style="color: red; padding-left: 10px;">Invalid Promocode</div>
							<div class="cpn_dvd" style="display:block"></div>
							<div class="clearfix"></div>
							<div class="coupn_inr">
								<div class="coupn_scrl">
									<div class="coupn_col">
										<label class="coupn_radio" *ngFor="let promocode of promocodeList; let index=index">
											<div class="coupn_ttl">{{promocode.promo_code}}</div>
											<div class="coupn_para" id="cpnTxtEMTNCF">{{promocode.description}}</div>
											<input type="radio" (click)="setSelectedPromo(promocode, index)" name="cpnRadio">
											<span class="coupn_checkmark" id="spnRdoEMTNCF"></span>
											<span *ngIf="promocode.selected">
												<a href="javascript:void(0);" (click)="removeSelectedPromo()" style="color: red; font-size: 11px;">Remove</a>
											</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
